// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import router from './router'

import * as VueGoogleMaps from 'vue2-google-maps'

// Eventbus
import './event-bus.js'

// Vuex Store
import Store from './store'

// Pictures Viewer
import Viewer from 'v-viewer'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  /* theme: {
    primary: '#519fe4',
    secondary: '#2b63ae',
    accent: '#cc0088',
    error: '#b71c1c'
  } */
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCieZ-25nZS_XqzFYcMupMts_VB4indwkQ'
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})

Vue.use(Viewer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  store: Store
})



// WEBPACK FOOTER //
// ./src/main.js